<template>
	<div>
		<list-polls-evaluation360
			:clean-search="cleanSearch"
			:columns="columns"
			:name="toolCode"
			:rows="rows"
            :total-items-visible="7"
            :total-items="totalItems"
            :last-page="totalPages"
            :current-page="params.page"
			@on-page="changePage"
			@on-search="onSearch"
			@on-click="onClickAction"
			@changeSort="changeSort"
		></list-polls-evaluation360>

		<open-modal
			:footer="false"
			:dialog="dialog"
			@close-modal="visibleModal"
		>
			<surveys-form
				:btn-disabled="!surveyName"
				btn-text="Duplicar"
				:survey-name="surveyName"
				@call-to-action="cloneSurvey"
			></surveys-form>
		</open-modal>
	</div>
</template>

<script>
	import openModal from '@/components/configuration/open-modal';
	import surveysForm from '@/components/surveys/surveys-form';
	import listPollsEvaluation360 from '@/modules/evaluation-360/components/process/list-polls-evaluation360';

	function created() {
		this.loadData();
	}

	async function activeSurvey(surveyId, state) {
		const body = { state };
		try {
			await this.$http.patch(`polls/state/${surveyId}`, body);
			this.showNotification('El estado de la encuesta ha sido actualizado correctamente.');
			this.loadData();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function cloneSurvey(name) {
		const body = { name };
		try {
			await this.$http.post(`polls/clone/${this.surveyId}`, body);
			this.visibleModal(false);
			this.showNotification('La encuesta ha sido duplicada correctamente.');
			this.loadData();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadData() {
		const params = {
			toolCode: this.toolCode,
			...this.params,
		};
		this.cleanSearch = !params.search;
		try {
			const { data: response, headers } = await this.$http.get('polls', { params });
			this.rows = response;
			this.totalItems = Number(headers['x-quantity']);
			this.totalPages = Number(headers['x-last-page']);
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	function changePage(newPage) {
		this.params.page = newPage;
		this.loadData();
	}

	function changeSort({ fieldName, sortDirection }) {
		this.params.sortField = fieldName;
		this.params.sortDirection = sortDirection;
		this.loadData();
	}

	function onClickAction({ action, row }) {
		const { id, name, state } = row;
		const options = {
			clone: this.pollsClone.bind(this, id, name),
			state: this.activeSurvey.bind(this, id, Number(state)),
			delete: this.pollsDelete.bind(this, id, name),
		};
		options[action].call();
	}

	function pollsClone(id, name) {
		this.surveyId = id;
		this.surveyName = `${name}_copy`;
		this.visibleModal(true);
	}

	async function pollsDelete(id, name) {
		try {
			await this.$http.delete(`polls/${id}`);
			const msg = `La encuesta "${name.toUpperCase()}" fue eliminada`;
			this.loadData();
			this.showNotification(msg, 'success');
		} catch (err) {
			this.showGenericError();
		}
	}

	function onSearch(searchVal) {
		const newSearch = searchVal ? searchVal.trim() : null;
		this.params.search = newSearch;
		this.params.page = 1;
		this.loadData();
	}

	function visibleModal(val) {
		this.dialog = val;
		if (!val) {
			this.surveyId = null;
			this.surveyName = '';
		}
	}

	function data() {
		return {
			cleanSearch: false,
			columns: [
				{
					id: 1,
					name: 'Nombre de encuesta',
					value: 'name',
					checked: true,
					visible: true,
					sortCheck: true,
					fieldName: 'name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'Cantidad Procesos.',
					value: 'diagnosis',
					checked: true,
					visible: true,
				},
				{
					id: 3,
					name: 'Aplicantes',
					value: 'aplicants',
					checked: true,
					visible: true,
				},
				{
					id: 4,
					name: 'Fecha',
					value: 'createdAt',
					checked: true,
					visible: true,
					sortCheck: true,
					fieldName: 'created_at',
					color: 'gray',
				},
				{
					id: 5,
					name: 'Acciones',
					checked: true,
					visible: true,
					flagVisible: true,
				},
			],
			dialog: false,
			rows: [],
			surveyId: null,
			surveyName: '',
			totalItems: 0,
			totalPages: 0,
			toolCode: 'E360',
		};
	}

	export default {
		name: 'surveys-list',
		components: {
			openModal,
			listPollsEvaluation360,
			surveysForm,
		},
		created,
		data,
		methods: {
			activeSurvey,
			cloneSurvey,
			changePage,
			changeSort,
			loadData,
			onClickAction,
			onSearch,
			pollsClone,
			pollsDelete,
			visibleModal,
		},
	};
</script>



// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/page-list-polls-evaluation360.vue